import { BugoData } from '@shared/api/bugo/bugo.interface';
import { CourtesyContent } from '@shared/api/courtesyAsset/courtesyAsset.interface';

//* CourtesyCotent를 해당 member의 정보에 맞게 string으로 변경
const getCourtesyStringFromContent = (
  courtesyContent: CourtesyContent,
  bugo: BugoData,
  useDeceasedName = false,
) => {
  const deceasedName = bugo?.fevent?.deceasedInfo?.name;
  const memberName = bugo?.member?.fullName ?? 'OOO';
  //!reverseType
  const reverseType = bugo?.member?.reverseType;
  const now = new Date();
  const dateString =
    now.getFullYear() + '년 ' + (now.getMonth() + 1) + '월 ' + now.getDate() + '일';

  let deceasedText: string;
  if (reverseType) {
    deceasedText = useDeceasedName
      ? `${reverseType}상(故 ${deceasedName}님)`
      : `${reverseType}상`;
  } else {
    deceasedText = `故${deceasedName}님 장례`;
  }

  return courtesyContent.content
    .replace('故${deceasedName}님 장례', deceasedText)
    .replace('故 ${deceasedName}님 장례', deceasedText)
    .replace('${deceasedName}', deceasedName)
    .replace('${memberName}', memberName)
    .replace('${dateString}', dateString);
};

export { getCourtesyStringFromContent };
